import { cn } from '@commenda/utils';

const DAY_HEADERS = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];

// Deterministic pill layout per cell — avoids hydration mismatch and looks natural
const CELL_PILLS: number[][] = [
  [2], [], [1], [3], [], [2], [1],
  [], [1], [2], [], [3], [1], [],
  [2], [3], [], [1], [2], [], [1],
  [1], [], [2], [3], [1], [], [2],
  [], [2], [1], [], [2], [3], [],
];

const PILL_WIDTHS = ['75%', '60%', '85%', '50%', '70%'];
const DELAYS = ['0ms', '100ms', '200ms', '300ms', '400ms', '500ms', '600ms'];

interface PillSkeletonProps {
  width: string;
  delay: string;
}

const PillSkeleton = ({ width, delay }: PillSkeletonProps) => (
  <div
    className="h-5 rounded animate-pulse motion-reduce:animate-none bg-bg-disabled-subtle"
    style={{ width, animationDelay: delay }}
  />
);

const CalendarSkeleton = () => {
  return (
    <div className="flex flex-col flex-1 min-h-0 border border-border-primary rounded overflow-hidden">
      <div className="grid grid-cols-7 border-b border-border-primary">
        {DAY_HEADERS.map((day) => (
          <div
            key={day}
            className="py-2 text-center txt-small-medium text-fg-tertiary border-r border-border-primary last:border-r-0"
          >
            {day}
          </div>
        ))}
      </div>

      <div className="grid grid-cols-7 grid-rows-5 flex-1">
        {CELL_PILLS.map((pills, cellIndex) => {
          const col = cellIndex % 7;
          const globalDelay = DELAYS[cellIndex % DELAYS.length]!;

          return (
            <div
              key={cellIndex}
              className={cn(
                'border-b border-border-primary p-1.5 flex flex-col gap-1 min-h-[100px]',
                col !== 6 && 'border-r'
              )}
            >
              <div
                className="self-end h-5 w-6 rounded animate-pulse motion-reduce:animate-none bg-bg-disabled-subtle mb-0.5"
                style={{ animationDelay: globalDelay }}
              />
              {pills.map((_, pillIndex) => (
                <PillSkeleton
                  key={pillIndex}
                  width={PILL_WIDTHS[(cellIndex + pillIndex) % PILL_WIDTHS.length]!}
                  delay={DELAYS[(cellIndex + pillIndex * 2) % DELAYS.length]!}
                />
              ))}
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default CalendarSkeleton;
